import { ElementRef } from '@angular/core';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { SessionService } from '../session-service.service';

@Directive({
  selector: '[appConfigSettingsNavigationStep]'
})
export class ConfigSettingsNavigationStepDirective implements OnInit {
  FontTypeEnum = FontTypeEnum;

  constructor(private elementRef: ElementRef<any>, private sessionService: SessionService) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().fontColor;
    this.elementRef.nativeElement.style.fontFamily = FontTypeEnum[this.sessionService.getConfigSettingsDto().fontType] || FontTypeEnum.Sun;
  }
}
